<template>
  <div class="page-loading" v-if="loading">
    <div class="line-1">
      <div class="line-1-left">
      </div>
      <div class="line-1-content">
      </div>
      <div class="line-1-right">
      </div>
    </div>
    <div class="line-2">
      <div class="line-2-left">
      </div>
      <div class="line-2-content">
        <div class="line-2-content-1">
        </div>
        <div class="line-2-content-2">
        </div>
        <div class="line-2-content-3">
        </div>
      </div>
    </div>
    <div class="line-3">
      <div class="progress-rate">
        <div class="progress-ok" :style="loading_style">
        <div class="progress-hide" v-if="loadingPercentage > 20">
            {{loadingPercentage + '%'}}
          </div>
        </div>
      </div>
    </div>
    <div class="line-4">
      <div class="line-4-content">
      </div>
      <div class="line-4-right">
      </div>
    </div>
    <div class="jiao-tl">
    </div>
    <div class="jiao-rb">
    </div>
    <div class="jiao-zl">
    </div>
    <div class="jiao-zr">
    </div>
    <a href="javascript:;" @click="loading = false" class="close-loading">
    X
    </a>
    <div class="loading-title-block">
      <span class="icon-1">》</span><span class="loading-title">》{{loadingText}}</span><span class="icon-2">《</span><span class="icon-1">《 </span>&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <div class="loading-loading-block">
      <span class="loading-text">Loading...</span>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        loadingPercentage: 0,
        startTime: 80,
        nextTime: 200
      }
    },
    methods: {
      closeLoading () {
        let vm = this
        window.setTimeout(function () {
          vm.$store.dispatch('setLoading', false)
        }, 1000)
      },
      addPercentage (time) {
        window.setTimeout(this.add, time)
      },
      add () {
        if (this.percentage.next > this.loadingPercentage) {
          this.loadingPercentage ++
        }
        if (this.percentage.start > this.loadingPercentage) {
          this.startTime = this.startTime > 24 ? this.startTime - 5 : this.startTime
          this.addPercentage(this.startTime)
        } else if (this.percentage.next * 0.9 > this.loadingPercentage) {
          this.nextTime = this.nextTime + 200
          this.addPercentage(this.nextTime)
        }
        if (this.loadingPercentage === 100) {
          this.closeLoading()
        }
      }
    },
    computed: {
      loading: {
        get () {
          return this.$store.getters.loading
        },
        set (value) {
          this.$store.dispatch('setLoading', false)
        }
      },
      loadingText: {
        get () {
          return this.$store.getters.loadingText
        }
      },
      percentage: {
        get () {
          return this.$store.getters.percentage
        },
        set (value) {
          this.$store.dispatch('setPercentage', value)
        }
      },
      loading_style: {
        get () {
          return {
            width: this.loadingPercentage + '%'
          }
        }
      }
    },
    watch: {
      percentage () {
        this.startTime = 80
        this.nextTime = 200
        if (this.percentage.start === 0) {
          this.loadingPercentage = 0
        }
        if (this.percentage.start > this.loadingPercentage) {
          this.addPercentage(80)
        } else if (this.percentage.next * 0.9 > this.loadingPercentage) {
          this.addPercentage(200)
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  @loading-bak-color: rgba(16,22,54,0.7);
  @border-color: #598ec5;
  @border-style: 1px solid @border-color;
  .hide-loading {
    display: none;
  }
  .progress-hide {
    padding:0 10px;
    color: #fff;
    font-size: 14px;
  }
  .progress-rate {
    display: flex;
    height: 20px;
    border-radius: 10px;
    margin: 0 20px 20px;
    background-image: linear-gradient(to bottom, #1e1e1e, #3a3a3a);
    background-color: #fff;
  }
  .progress-ok {
    text-align: right;
    border-radius: 10px;
    transition: 0.5s;
    background-image: linear-gradient(to bottom, #0084f3, #00346f);
  }
  .loading-title-block {
    position: absolute;
    letter-spacing: 2px;
    width: 100%;
    padding-right: 10px;
    text-align: center;
    top: 10px;
  }
  .loading-loading-block {
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: 10px;
  }
  .loading-text {
    color: #00ccff;
    font-size: 14px;
  }
  .loading-title {
    color: #00ccff;
    font-size: 20px;
  }
  .icon-1 {
   color: @font-color-4;
   font-size: 20px;
   letter-spacing: -0.65em;
 }
 .icon-2 {
  font-size: 20px;
  color: #00ccff;
  letter-spacing: -0.65em;
}
.jiao-tl {
  position: absolute;
  top: 28px;
  left: 4px;
  width: 19px;
  height: 22px;
  transform:rotate(45deg);
  border-left: @border-style;
}
.jiao-rb {
  position: absolute;
  bottom: -9px;
  right: -9px;
  width: 19px;
  height: 22px;
  transform:rotate(45deg);
  border-left: @border-style;
}
.jiao-zl {
  position: absolute;
  top: -16px;
  right: 145px;
  width: 36px;
  height: 33px;
  transform:rotate(45deg);
  border-bottom: @border-style;
}
.jiao-zr {
  position: absolute;
  top: 7px;
  left: 170px;
  width: 32px;
  height: 35px;
  transform:rotate(45deg);
  border-left: @border-style;
}
.close-loading {
  font-weight: 600;
  position: absolute;
  top: 27px;
  background-image: linear-gradient(to bottom, #0084f3, #00346f);
  right: 5px;
  color: #fff;
  width: 20px;
  height: 20px;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  border-radius: 100%;
}
.page-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: 1s;
  transform:translate(-270px, -65px);
  width: 540px;
  height: 120px;
  z-index: 2000;
  display: flex;
  flex-direction:column;
}
.line-4-right {
  width:0;
  height:0;
  border-top: 15px solid @loading-bak-color;
  border-right: 15px solid transparent;
}
.line-4-content {
  flex: 1;
  background-color: @loading-bak-color;
  border-bottom: @border-style;
  border-left: @border-style;
}
.line-2-left {
  width:0;
  height:0;
  border-width:0px 0px 15px 15px;
  border-style:solid;
  border-color:transparent transparent @loading-bak-color;
}
.line-2-content {
  flex: 1;
  display: flex;
  background-color: @loading-bak-color;
}
.line-2-content-1 {
  width: 150px;
  border-top: @border-style;
}
.line-2-content-2 {
  width: 213px;
}
.line-2-content-3 {
  flex: 1;
  border-top: @border-style;
  border-right: @border-style;
}
.line-1-left {
  width:0;
  height:0;
  border-width:0px 0px 24px 24px;
  border-style:solid;
  border-color:transparent transparent @loading-bak-color;
}
.line-1-content {
  text-align: center;
  border-top: @border-style;
  width: 165px;
  background-color: @loading-bak-color;
}
.line-1-right {
  border-bottom: 24px solid @loading-bak-color;
  border-right: 24px solid transparent;
}
.line-1 {
  display: flex;
  height: 24px;
  justify-content:center;
}
.line-2 {
  display: flex;
  height: 15px;
}
.line-3 {
  flex-direction: column-reverse;
  flex: 1;
  border-left: @border-style;
  border-right: @border-style;
  display: flex;
  background-color: @loading-bak-color;
}
.line-4 {
  height: 15px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// Loading.vue?28969b54